/**
 * 格式化評價數量，大於10000顯示為"X萬+"格式
 * @param {number} number - 需要格式化的數字
 * @returns {string} 格式化後的數字字串
 */
export const formatNumber = (number) => {
  if (number < 10000) {
    return number.toLocaleString()
  } else {
    const rounded = Math.floor(number / 10000)
    return `${rounded}萬+`
  }
}

/**
 * 計算評分對應的星星數量
 * @param {number} rating - 評分數值(0-5)
 * @returns {Array} 返回包含 [滿星數量, 半星數量, 空星數量] 的陣列
 */
export const calculateStarsAmount = (rating) => {
  const fullStars = Math.floor(rating)
  const decimalPart = Math.round((rating - fullStars) * 10) / 10 // 精確到一位小數
  const halfStar = decimalPart >= 0.4 && decimalPart < 0.8 ? 1 : 0
  const fullStarsAdjusted = decimalPart >= 0.8 ? fullStars + 1 : fullStars
  const emptyStars = 5 - fullStarsAdjusted - halfStar
  return [fullStarsAdjusted, halfStar, emptyStars]
}
